/**
 * @file url处理相关API
 * @author zhoujiequn(zhoujiequn@bytedance.com)
 *  lizhuo(lizhuo@bytedance.com)
 */

// var = {

/**
     * 将url参数部分解析成key/value形式
     * @param {string} query 格式key=value&key=value
     * @returns {object} json 对象{key:value,key:value}
     */
export const queryToJson = function (query) {
  if (!query) {
    return {}
  }
  var reg = /^[?|#]{1}/
  if (reg.test(query)) {
    query = query.replace('?', '')
  }
  var result = {}
  var pairs = query.split('&')
  var i
  var keyValue
  var len
  for (i = 0, len = pairs.length; i < len; i++) {
    keyValue = pairs[i].split('=')
    result[keyValue[0]] = decodeURIComponent(keyValue[1])
  }
  return result
}

/**
     * json转换为url
     * @param {object} json json数据
     * @returns {string} url
     */
export const jsonToQuery = function (json) {
  if (!json) {
    return ''
  }
  var arr = []
  var key
  for (key in json) {
    if (json.hasOwnProperty(key)) {
      arr.push(key + '=' + encodeURIComponent(json[key]))
    }
  }
  return arr.join('&')
}

/**
     * 不刷新页面更新url的query
     * @param {object} newQueryObj 需要更新的query
     * @param {object} state 路由状态
     */
export const updateQueryNoRefresh = function (newQueryObj, state) {
  if (!newQueryObj) {
    return
  }
  var queryObj = queryToJson(window.location.search)
  var newUrl
  for (var key in newQueryObj) {
    if (newQueryObj.hasOwnProperty(key)) {
      queryObj[key] = newQueryObj[key]
    }
  }
  newUrl = window.location.pathname + '?' + jsonToQuery(queryObj)
  window.history.pushState(state || {}, 0, newUrl)
}

/**
     * 不刷新页面替换url的query
     * @param {object} newQueryObj - 新的query
     * @param {object} state - 路由状态
     */
export const replaceQueryNoRefresh = function (newQueryObj, state) {
  if (!newQueryObj) {
    return
  }
  var params = jsonToQuery(newQueryObj)
  var newUrl = window.location.pathname + (params ? '?' + params : '')
  window.history.pushState(state || {}, 0, newUrl)
}

/**
     * 不刷新页面删除url的某个query
     * @param {string} deleteKey 需要删除的query
     * @returns {boolean} deletedFlag true代表被删除，false代表不存在这个key
     */
export const deleteQueryNoRefresh = function (deleteKey) {
  if (!deleteKey) {
    return false
  }
  var queryObj = queryToJson(window.location.search)
  var newUrl
  if (!queryObj.hasOwnProperty(deleteKey)) {
    return false
  }
  delete queryObj[deleteKey]
  newUrl = window.location.pathname + '?' + jsonToQuery(queryObj)
  window.history.pushState({}, 0, newUrl)
  return true
}
export function updateQueryWithAdvid (href, queryObj = {}) {
  if (!href) {
    return href
  }
  if (href.startsWith('/pages/')) {
    href = window.location.protocol + '//' + ADOE_ORIGIN + href
  }
  const advertiser = (window.GLOBAL_VAR && GLOBAL_VAR.advertiser) || {}
  const aadvidObj = {
    aadvid: advertiser.id || ''
  }
  return addOrReplaceParam(href, {
    ...aadvidObj,
    ...queryObj
  })
}
/**
 * 给定URL增加|更新query参数
 * @param {string} 给定URL
 * @param {object} queryObj 要增加或者修改的 query参数
 */
export function addOrReplaceParam (href, queryObj = {}, res = false) {
  let pos
  let hash = ''
  let query = ''
  // extract fragment
  pos = href.indexOf('#')
  if (pos > -1) {
    hash = href.substring(pos) || ''
    href = href.substring(0, pos)
  }
  // extract query
  pos = href.indexOf('?')
  if (pos > -1) {
    query = href.substring(pos) || ''
    href = href.substring(0, pos)
  }

  var originQueryObj = queryToJson(query)
  var finalQuery = jsonToQuery({
    ...originQueryObj,
    ...queryObj
  })
  var finalHref = href + (finalQuery ? '?' + finalQuery : '') + hash
  // slardar打个log，排查一个一户多开 # 被 encode 的问题

  if (finalHref.indexOf('%23') > -1 && window.Slardar) {
    var logValue = {
      href,
      finalQuery,
      finalHref
    }
    window.Slardar('emit', 'log', {
      value: JSON.stringify(logValue),
      level: 'info',
      tags: {
        path: window.location.pathname
      }
    })
  }
  if (res) {
    return {
      href,
      finalQuery,
      finalHref,
      query: {
        ...originQueryObj,
        ...queryObj
      }
    }
  }
  return finalHref
}
export function getQueryWithAdvid (href = '', queryObj = {}) {
  const advertiser = (window.GLOBAL_VAR && GLOBAL_VAR.advertiser) || {}
  const aadvidObj = {
    aadvid: advertiser.id || ''
  }
  return addOrReplaceParam(href, {
    ...aadvidObj,
    ...queryObj
  }, true)
}

export default {
  queryToJson,
  jsonToQuery,
  updateQueryNoRefresh,
  replaceQueryNoRefresh,
  deleteQueryNoRefresh,
  updateQueryWithAdvid,
  addOrReplaceParam,
  getQueryWithAdvid
}
